import { getSrcs } from '@helpers/image';
import SvgArrow from '@img/icons/arrow-right.svg';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useSwipeable } from 'react-swipeable';
import S from './LandingPageHero.styles';
import { useAutoplay } from '@hooks/useAutoplay';
const LandingPageHero = (props) => {
    const { activeIndex, setActiveIndex } = useAutoplay({
        enabled: props.items.length > 1,
        duration: props.autoplayDuration || 0,
        items: props.items,
    });
    const vidRef = React.useRef(null);
    const [paused, setPaused] = React.useState(false);
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => handleNextClick(),
        onSwipedRight: () => handlePrevClick(),
    });
    if (!props.items) {
        return null;
    }
    const handleNextClick = () => {
        const nextIndex = activeIndex + 1 === props.items.length ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };
    const handlePrevClick = () => {
        const prevIndex = activeIndex === 0 ? props.items.length - 1 : activeIndex - 1;
        setActiveIndex(prevIndex);
    };
    const handlePlayPauseClick = () => {
        if (!vidRef.current) {
            return;
        }
        if (paused) {
            setPaused(false);
            vidRef.current.play();
        }
        else {
            setPaused(true);
            vidRef.current.pause();
        }
    };
    return (React.createElement(S.Container, { ...swipeHandlers, ref: (r) => {
            swipeHandlers.ref(r);
        }, spacing: "none" },
        React.createElement(S.List, null, props.items.map((item, index) => renderItem(item, index === activeIndex, vidRef))),
        React.createElement(S.BottomWrapper, null,
            React.createElement(S.ScrollIndicator, null, "Scroll"),
            props.items.length > 1 && (React.createElement(S.Controls, null,
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.ControlButton, { onClick: (e) => {
                            e.preventDefault();
                            handlePrevClick();
                        }, "aria-label": "Go to previous image" },
                        React.createElement(SvgArrow, null))),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.ControlButton, { onClick: (e) => {
                            e.preventDefault();
                            handleNextClick();
                        }, "aria-label": "Go to next image" },
                        React.createElement(SvgArrow, null))))),
            props.items.length === 1 && props.items[0].video !== null && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.PlayPauseButtonWrapper, null,
                    React.createElement(S.PlayPauseButton, { "data-paused": paused, "aria-label": `${paused ? 'Resume' : 'Pause'} banner scrolling`, onClick: (event) => {
                            event.preventDefault();
                            handlePlayPauseClick();
                        } })))))));
    function renderItem(item, isActive, vidRef) {
        const cssVars = {
            '--blur': item.imageBlur ? `${item.imageBlur}px` : undefined,
            '--tint': item.imageTint ? item.imageTint : undefined,
        };
        const srcs = getSrcs(item.image, 2568, 375, 10);
        return (React.createElement(S.Item, { key: item.id, style: cssVars, "data-active": isActive },
            React.createElement(S.Inner, null,
                React.createElement(S.TitleArea, null,
                    item.tagline && React.createElement(S.Tagline, null, item.tagline),
                    React.createElement(S.Title, null, item.title),
                    item.intro && React.createElement(S.Intro, null, item.intro)),
                item.cta && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { buttonType: "inverted", href: item.cta.url, target: item.cta.target }, item.cta.text)))),
            React.createElement(S.ImageWrapper, null,
                item.video !== null ? (React.createElement(S.Video, { ref: vidRef, autoPlay: true, preload: "auto", loop: true, muted: true, playsInline: true, poster: srcs[0].split(' ')[0] },
                    React.createElement("source", { src: item.video.url, type: "video/mp4" }))) : (React.createElement(S.Image, { alt: item.image.altText ?? '', loading: "eager", role: item.image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') })),
                item.showOverlay && React.createElement(S.Overlay, null))));
    }
};
export default LandingPageHero;
